module.exports = __webpack_public_path__ + "img/skypets-4.50a57df0.webp";